import { Helmet } from "react-helmet";
import { Heading, Img, Button, Text } from "../../components";
import CarCard from "../../components/CarCard";
import UserProfile1 from "../../components/UserProfile1";
import React, { Suspense, use, useEffect } from "react";
import RightSideMenuProvider from "components/RightSideMenuProvider";
const ITEMS = [
  { key:"all"     , title:"כל המודעות"       , color:"black"   , img:"/images/black-car.svg" },
  { key:"noOffers", title:"מודעות שממתינות להצעה", color:"black"   , img:"/images/black-car.svg" },
  { key:"dismantling", title:"רכבים לפירוק", color:"#CE0000", img:"/images/red-car.svg" },
  { key:"rehabilitation", title:"רכבים לשיקום", color:"#619D1C", img:"/images/green-car.svg" },
  { key:"pending" , title:"מודעות עם הצעת מחיר"  , color:"#CE0000", img:"/images/red-car.svg"   },
  { key:"approved", title:"מודעות מאושרות"       , color:"#619D1C", img:"/images/green-car.svg" },
  { key:"archive" , title:"מודעות בארכיון"       , color:"#666666", img:"/images/gray-car.svg"  },
  { key:"auction" , title:"מודעות במכרז פעיל"       , color:"#FF8C42", img:"/images/orange-offer.svg" },
  { key:"auction_future" , title:"מודעות במכרז עתידי"       , color:"#FFB400", img:"/images/orange-offer.svg" },
];

export default function MyAdsProvider({ counters = {}, adminMode = false }) {

  return (

    <div className="hide-mobile ads-counter-panel my-ads-provider flex w-[10%] flex-col gap-3 rounded-[24px] bg-secondary-primary_white p-6 shadow-xs md:w-full sm:p-4" style={{top: '1rem', position: 'fixed', left: '2rem', height: '96vh'}}>
    <div className="flex justify-center">
      <Heading size="text2xl" as="h1" className="mt-1.5 !font-heebo text-[18px] font-medium lg:text-[15px]">
        {adminMode ? "מודעות" : "המודעות שלי"}
      </Heading>
    </div>
    <div className="h-px bg-blue_gray-100" />
    <div className="ads-counter-panel-list mb-[244px] flex flex-col gap-3">
      <Suspense fallback={<div>Loading feed...</div>}>
      {ITEMS.map(it=>(
                  <UserProfile1 
                  key={it.key}
                myAd={{
                  number: counters[it.key] ?? 0,
                  title : it.title,
                  color : it.color,
                  img   : it.img,
                }}
          />
        ))}
      </Suspense>
    </div>
  </div>
  );
}
